import { Ref, watch } from "vue";
import Konva from "konva";
import { getStagePosition, setReactPositionToList } from "./common";

const useRecSelect = (
  stage: Ref<Konva.Stage | null>,
  layer: Ref<Konva.Layer | null>,
  enable: Ref<boolean>,
  onCreated?: (rect: Konva.Rect) => void
) => {
  let isPaint = false;
  let rect: Konva.Rect | undefined;
  let startX = 0;
  let startY = 0;
  watch(
    [stage, layer],
    (val) => {
      const [newStage, newLayer] = val;
      if (!newStage || !newLayer) return;
      newStage.on("touchstart", function () {
        if (!enable.value) return;
        isPaint = true;
        const [x, y] = getStagePosition(newStage, 0);
        startY = y;
        startX = x;
        rect = new Konva.Rect({
          x,
          y,
          width: 0,
          height: 0,
          fill: "#fff",
          opacity: 0.4,
          draggable: false,
        });
        newLayer.add(rect!);
        if (onCreated) {
          onCreated(rect!);
        }
      });
      newStage!.on("touchmove", function () {
        if (!isPaint) {
          return;
        }
        const [x, y] = getStagePosition(newStage, 0);
        const width = x - startX;
        const height = y - startY;
        rect!.width(width);
        rect!.height(height);
        layer.value?.batchDraw();
      });

      newStage!.on("touchend", function () {
        isPaint = false;

        setReactPositionToList();
      });
    },
    { immediate: true }
  );
};

export default useRecSelect;
